// @vendors
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// @store
import useAuthStore from '../../store/useAuthStore';
import routesConfig from '../../config/routes.config';
import { useCompanyStore } from '../../store/useCompanyStore';

const UserRoleNavigation: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, roleList } = useAuthStore();
  const { data } = useCompanyStore();

  const hasMultipleRoles = (roles?: string[]) => {
    if (!roles || !Array.isArray(roles)) return false;
    return roles.includes('USER') && roles.includes('PROFESSIONAL');
  };

  if (!isAuthenticated || !hasMultipleRoles(roleList as unknown as string[] | undefined)) {
    return null;
  }
  const isUserMode = !location.pathname.includes('professional');

  const handleClick = async () => {
    const navLocation = data?.isActive ? routesConfig.dashboardProfessional : routesConfig.userProfessional;
    return navigate(navLocation);
  }

  return (
    <div className="mt-4 lg:mt-0 w-full flex justify-center border-b border-gray-200 dark:border-white/80 pb-4">
      <div className="flex">
        <div
          onClick={() => navigate(routesConfig.home)}
          className={`px-6 py-2 cursor-pointer transition-colors text-[15px] ${isUserMode
            ? 'border-bgBrand text-bgBrand dark:text-bgBrand font-semibold'
            : 'border-transparent hover:border-gray-300 dark:text-white'
            }`}
        >
          {t("professional.navigationLikeUser")}
        </div>
        <div className="w-px bg-gray-200" />
        <div
          onClick={handleClick}
          className={`px-6 py-2 cursor-pointer transition-colors text-[15px] ${!isUserMode
            ? 'border-bgBrand text-bgBrand dark:text-bgBrand font-semibold'
            : 'border-transparent hover:border-gray-300'
            }`}
        >
          {t("professional.navigationLikeCompany")}
        </div>
      </div>
    </div>
  );
};

export default UserRoleNavigation;